(function () {
  const fileInput = document.querySelector('#practitioner-certificate-file');
  const signUpForm = document.querySelector('#pro-account-sign-up-form');
  const password = document.querySelector('#password');
  const confirmPassword = document.querySelector('#confirm_password');
  const message = document.querySelector('#message');
  const messageComplexity = document.querySelector('#messageComplexity');
  const expertiseSelect = document.querySelector('#expertise');
  const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
  document.addEventListener('DOMContentLoaded', main);
  function main() {
    fileInput?.addEventListener('change', handleFileInputChanged);
    signUpForm?.addEventListener('submit', handleFormSubmit);
    confirmPassword?.addEventListener('input', validatePasswords);
    password?.addEventListener('input', () => {
      validatePasswords();
      validatePasswordComplexity();
    });
    if (expertiseSelect) {
      expertiseSelect?.addEventListener('change', handleExpertiseChanged);
    }
  }
  function handleFileInputChanged(e) {
    const target = e.target;
    const fileName = target.value.split('\\').pop() || '';
    if (fileName) {
      document.querySelector('#file-upload-name').title = fileName;
      document.querySelector('.file-name').innerText = fileName;
    }
  }
  async function handleFormSubmit(e) {
    const form = e.target;
    if (!form) return;
    const honeypot = form.querySelector('[name="company_name"]');
    if (honeypot && honeypot.value.trim() !== '') {
      console.warn('Bot submission detected — form not submitted.');
      return; // silently stop submission
    }
    validatePasswords();
    if (form.checkValidity() === false) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    toggleSubmitLoading();
    try {
      const response = await submitSignUpForm(form);
      if (response.ok) {
        toggleSuccessMessage();
      } else {
        const responseData = await response.json();
        const submitFailedMessage = document.querySelector('#submit-failed-message');
        if (responseData.errors) {
          handleErrorMessages(responseData.errors);
        }
        if (submitFailedMessage && responseData.message) {
          submitFailedMessage.innerText = responseData.message;
          submitFailedMessage.classList.remove('hidden');
        }
      }
      toggleSubmitLoading();
    } catch (error) {
      const submitFailedMessage = document.querySelector('#submit-failed-message');
      if (submitFailedMessage) {
        submitFailedMessage.innerText = 'Could not submit the form.';
      }
      toggleSubmitLoading();
    }
    // TODO: update loading state
  }
  function handleErrorMessages(errors) {
    if (errors.phone) {
      const errorPhone = document.querySelector('#error-phone');
      if (errorPhone) {
        errorPhone.textContent = errors.phone[0];
        const phoneInput = document.querySelector('#phone');
        if (phoneInput) {
          phoneInput.addEventListener('change', () => {
            const errorPhone = document.querySelector('#error-phone');
            if (errorPhone && errorPhone.textContent !== '') {
              errorPhone.textContent = '';
            }
          });
        }
      }
    }
  }
  async function uploadPractitionerCertificateFile() {
    const fileInputEl = fileInput;
    if (!fileInputEl) return null;
    const selectedFile = fileInputEl.files?.[0];
    if (!selectedFile) return null;
    const fileFormData = new FormData();
    fileFormData.append('file', selectedFile);
    try {
      const response = await fetch(`${window.apiurl}/public/api/upload-practitioner-certificate`, {
        method: 'POST',
        body: fileFormData,
      });
      if (!response.ok) {
        throw new Error('Failed to upload practitioner certificate');
      }
      const { fileName } = await response.json();
      return fileName;
    } catch (error) {
      console.error(error);
      if (Bugsnag) {
        Bugsnag.notify(error);
      }
      return null;
    }
  }
  async function submitSignUpForm(form) {
    const signUpForm = new FormData(form);
    const fileName = await uploadPractitionerCertificateFile();
    if (fileName) {
      signUpForm.set('practitioner_certificate_file', fileName);
    }
    const dataObject = Object.fromEntries(signUpForm.entries());
    return fetch(`${window.apiurl}/public/api/create-user`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(dataObject),
    });
  }
  function validatePasswords() {
    if (!password || !confirmPassword)
      throw new Error('Could not find password or password confirm inputs');
    if (password.value !== confirmPassword.value) {
      message.textContent = 'Passwords do not match';
      confirmPassword.setCustomValidity('Passwords do not match');
    } else {
      message.textContent = '';
      confirmPassword.setCustomValidity('');
    }
  }
  function validatePasswordComplexity() {
    if (!passwordPattern.test(password.value)) {
      messageComplexity.textContent =
        'Your password must be at least 8 characters long and include both a letter and a number.';
      password.setCustomValidity('Password does not meet complexity requirements');
    } else {
      messageComplexity.textContent = '';
      password.setCustomValidity('');
    }
  }
  function toggleSuccessMessage() {
    document.querySelector('.pro-accounts__content.form')?.classList.toggle('hidden');
    document.querySelector('.pro-accounts__content.success')?.classList.toggle('hidden');
    // TODO: Update loading state
  }
  function toggleSubmitLoading() {
    signUpForm.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden');
    signUpForm.querySelector('button')?.classList.toggle('loading');
  }
  function handleExpertiseChanged(e) {
    const target = e.target;
    const otherExpertiseWrapper = document.querySelector('#expertise_other_wrapper');
    const otherInput = otherExpertiseWrapper?.querySelector('input');
    if (target.id !== 'expertise' || !otherExpertiseWrapper || !otherInput)
      throw new Error('Pro account register form: Cannot find expertise dropdown elements');
    const enableOtherField = target.value === 'other - please specify';
    otherExpertiseWrapper.classList.toggle('hidden', !enableOtherField);
    otherInput.required = enableOtherField;
  }
})();
